module.exports = __webpack_public_path__ + "static/media/lp-plan-05.50adc52c.png";